module.exports = __webpack_public_path__ + "img/callosités.2505fdad.jpg";